var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddFileIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 87,
    viewBox: "0 0 74 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.622 30.9325H58.688C50.7537 30.9109 44.3057 24.4455 44.3057 16.5242V3.91853C44.3057 2.12453 45.7617 0.668533 47.5557 0.668533C49.3497 0.668533 50.8057 2.12453 50.8057 3.91853V16.5242C50.8057 20.8749 54.346 24.4195 58.6967 24.4325H70.622C72.416 24.4325 73.872 25.8885 73.872 27.6825C73.872 29.4765 72.416 30.9325 70.622 30.9325Z",
    fill: "#721C31"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.7718 51.2111H25.543C23.749 51.2111 22.293 49.7551 22.293 47.9611C22.293 46.1671 23.749 44.7111 25.543 44.7111H46.7718C48.5658 44.7111 50.0218 46.1671 50.0218 47.9611C50.0218 49.7551 48.5658 51.2111 46.7718 51.2111Z",
    fill: "#721C31"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.1587 61.8286C34.3647 61.8286 32.9087 60.3726 32.9087 58.5786V37.3453C32.9087 35.5513 34.3647 34.0954 36.1587 34.0954C37.9527 34.0954 39.4087 35.5513 39.4087 37.3453V58.5786C39.4087 60.3726 37.9527 61.8286 36.1587 61.8286Z",
    fill: "#721C31"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8158 7.21745C12.6312 7.21745 6.67284 13.0328 6.50384 20.2045V67.1387C6.37817 74.2757 12.0418 80.1344 19.1268 80.2557L19.7638 80.2514H54.4825C61.5978 80.1734 67.4002 74.293 67.3915 67.143V28.1475L47.3108 7.21745H19.8158ZM19.0662 86.7557C8.34984 86.5694 -0.178164 77.7424 0.00383628 67.0824V20.1265C0.250836 9.37545 9.12984 0.717453 19.8028 0.717453H48.6932C49.5772 0.717453 50.4222 1.07712 51.0375 1.71412L72.9902 24.5898C73.5665 25.1921 73.8915 26.0025 73.8915 26.8388V67.1387C73.9088 77.8377 65.2162 86.6387 54.5172 86.7514L19.0662 86.7557Z",
    fill: "#721C31"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddFileIcon);
export default __webpack_public_path__ + "static/media/add-file-icon.11952a6f643fbbdf33141d296b1cc765.svg";
export { ForwardRef as ReactComponent };